'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { PartnerButton } from '../partner/partner-button';
import { Modal } from '../ui/modal';
import { PackageModalContent } from './package-modal-content';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export function PackageCard({ item }: { item: TDynamicData }) {
  const { t } = useTranslations();

  const subtitle = item.fields[0]?.value;
  const description = item.fields[1]?.value;
  const itemIncludesContent = item.fields[2]?.value;
  const description2 = item.fields[3]?.value;
  const goodForContent = item.fields[4]?.value;
  const iconUrl = item?.image?.url ?? '';
  const shortDescription = item.fields[6]?.value;
  const investment = item.fields[7]?.value;

  const isExperience = item.name === 'Experience';

  return (
    <div
      className={cn(
        'relative col-span-1 flex w-full flex-col items-start justify-start gap-8 rounded-[16px] p-6 sm:gap-10 sm:p-7 lg:gap-12 lg:p-8',
        isExperience ? 'bg-[#3A332C]' : 'bg-white',
      )}
    >
      <div className="absolute right-6 top-6 z-10 flex h-14 w-14 items-center justify-center rounded-full bg-[#F2EDE6] sm:right-7 sm:top-7 lg:right-8 lg:top-8">
        <Image src={iconUrl} alt={resolveImageAlt(item?.image, item?.name)} width={24} height={24} className="shrink-0" />
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-5 lg:gap-6">
        <h5
          className={cn(
            'text-sm font-medium text-primary sm:text-base',
            isExperience && 'text-[#D3C7B8]',
          )}
        >
          {t('text3548')}
        </h5>
        <Heading title={item.name} className={{ title: cn(isExperience && 'text-white') }} />
        <Paragraph
          className="w-full max-w-[300px]"
          size="lg"
          color={isExperience ? 'white' : 'foreground'}
        >
          {shortDescription}
        </Paragraph>
      </div>
      <div className="flex w-full flex-col items-center justify-center gap-2">
        <PartnerButton className="w-full" />
        <Modal
          className={{
            content: cn(
              'max-h-[88dvh] w-full max-w-[878px] overflow-y-scroll rounded-[16px] border-none p-6 sm:max-h-[90dvh] sm:max-w-[878px] sm:p-8 md:p-8 lg:p-8 xl:p-8',
              'ea-package-card__modal-content',
              'hide-scroll-bar',
            ),
          }}
          trigger={
            <div className="flex h-[52px] items-center justify-center">
              <span
                className={cn(
                  'cursor-pointer text-sm font-bold uppercase text-primary underline',
                  isExperience && 'text-white',
                )}
              >
                {t('text3549')}
              </span>
            </div>
          }
        >
          <PackageModalContent
            name={item.name}
            subtitle={subtitle}
            description={description}
            itemIncludesContent={itemIncludesContent}
            description2={description2}
            goodForContent={goodForContent}
            investment={investment}
          />
        </Modal>
      </div>
    </div>
  );
}
